import { render } from "./NotificationsMenu.vue?vue&type=template&id=33cc0c41&ts=true"
import script from "./NotificationsMenu.vue?vue&type=script&lang=ts"
export * from "./NotificationsMenu.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Vue\\donaska-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__